import { createBrowserHistory } from 'history';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from '@reduxjs/toolkit';

import legacyReducers from './reducers';
import catalogReducer from './slices/catalog';
import customizationReducer from './slices/customization/customization';
import pageShownCountersReducer from './slices/pageShownCounters/pageShownCounters';
import surveyVariablesReducer from './slices/surveyVariables/surveyVariables';
import projectVariablesReducer from './slices/projectVariables/projectVariables';
import endOfSurveyPageReducer from './slices/endOfSurveyPage/endOfSurveyPage';
import displayedSubItemsReducer from './slices/displayedSubItems';
import conceptTestReducer from './slices/conceptTest';
import visualizationTypesReducer from './slices/visualizationTypes';
import surveyPreviewLoadingReducer from './slices/surveyPreviewLoading';
import clipboardPasteReducer from './slices/clipboardPaste';
import { responsesReducer } from './slices/responses';
import { methodologyReducer } from './slices/methodology';
import { RESET_SURVEY } from './actions/types/global';
import { communityPropertiesReducer } from './slices/communityProperties';
import { basInfoReducer } from './slices/basInfo';
import metaReducer from './slices/meta';

export const routerHistory = createBrowserHistory();

const appReducer = combineReducers({
  router: connectRouter(routerHistory),
  catalog: catalogReducer,
  customization: customizationReducer,
  displayedSubItems: displayedSubItemsReducer,
  endOfSurveyPage: endOfSurveyPageReducer,
  pageShownCounters: pageShownCountersReducer,
  projectVariables: projectVariablesReducer,
  surveyVariables: surveyVariablesReducer,
  conceptTest: conceptTestReducer,
  surveyPreviewLoading: surveyPreviewLoadingReducer,
  visualizationTypes: visualizationTypesReducer,
  clipboardPaste: clipboardPasteReducer,
  responses: responsesReducer,
  methodology: methodologyReducer,
  communityProperties: communityPropertiesReducer,
  meta: metaReducer,
  basInfo: basInfoReducer,
  ...legacyReducers,
});

export const rootReducer = (state, action): ReturnType<typeof appReducer> => {
  if (action.type === RESET_SURVEY) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
export type GetState = () => RootState;

export interface ThunkAPI {
  state: RootState;
}
